<template>
	<div class="mod-config">
		<el-card body-style="padding-bottom: 0;" style="margin-top: -5px;">
			<div class="title">监理日志</div>
			<div class="line"></div>
		</el-card>
		<div>
			<el-card style="margin-top: -3px; height: 600px;" body-style="height:560px; padding: 0;">
				<el-row style="height: 100%; margin-bottom: 10px;">
					<el-col :span="24" style="height: 100%;">
						<div class="box">
							<el-table height="540" :row-class-name="tableRowClassName" :row-style="selectRowBackground"
								class="dataListTable" :data="dataList" header-align="center" border
								style="width: 100%; margin-bottom: 20px;" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }" @selection-change="handleSelectionChange">
								<el-table-column header-align="center" align="center" width="80" type="selection"
									label=" "></el-table-column>
								<el-table-column type="index" label="NO." width="100" align="center">
									<template slot-scope="scope">{{ (pageIndex2 - 1) * page + scope.$index + 1
										}}</template>
								</el-table-column>
								<el-table-column prop="logNo" label="Shift No" align="center">
								</el-table-column>
								<el-table-column prop="logDate" label="日期" width="400" align="center">
								</el-table-column>
								<el-table-column label="确认状态" width="100" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.refirmFlg === '1'">已确认</span>
										<span v-else>未确认</span>
									</template>
								</el-table-column>
								<el-table-column prop="refirmMan" label="确认人" width="110" align="center">
								</el-table-column>
								<el-table-column prop="refirmTime" label="确认时间" width="110" align="center">
								</el-table-column>
							</el-table>
						</div>
						<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
							@current-change="currentChangeHandle" :current-page="page" :page-sizes="[10, 20, 50, 100]"
							:page-size="limit" :total="totalCount" layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</el-col>
				</el-row>
			</el-card>
		</div>
	</div>
</template>
<script>
import $common from "@/utils/common.js"
export default {
	data() {
		return {
			refirmVisible: false,
			showSearch: false,
			showDownload: false,
			showAdd: false,
			showEdit: false,
			showDelete: false,
			showCheck: false,
			showArchive: false,
			showRowDownload: false,
			pageSpan: 12,
			addOrUpdateVisible: false,
			userPresetVisible: false,
			uploadVisible: false,
			exportVisible: false,
			auditVisible: false,
			enclosureVisible: false,
			disabledBatchDelete: true,
			addVisible: false,
			updateVisible: false,
			form: {},
			logNo: '',
			limit: 20,
			// 显示序号
			pageIndex2: 1,
			page: 1,
			totalCount: 0,
			dataList: [],
			logTime: [],
			tableSelVal: []

		};
	},
	components: {
	},
	mounted() {
		this.getDataList();
	},
	methods: {
		enclosureHandle(id) {
			this.enclosureVisible = true
			this.$nextTick(() => {
				this.$refs.enclosureAddOrUpdate.init(id)
			})
		},
		selectFile(url) {
			window.open(url);
		},
		//重置
		resetFormData() {
			this.pageIndex = 1;
			this.getDataList();
		},
		downloadHandle(workLogKind, url, fileName) {
			if (this.$store.state.showTestFlag) {
				window.open(url)
			} else {
				if (workLogKind == null || workLogKind == undefined || workLogKind == '' || workLogKind == '0') {
					this.global.downLoadFile(url, fileName + '.docx');
				} else {
					fileName = this.getSuffix(url, fileName)
					this.global.downLoadFile(url, fileName);
				}
			}
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/workloginfo/list",
				method: 'get',
				params: this.$http.adornParams({
					limit: this.limit,
					page: this.page,
					logNo: this.logNo,
					workNo: $common.getItem("workNo"),
					beginTime: this.logTime[0] ? this.logTime[0] : "",
					endTime: this.logTime[1] ? this.logTime[1] : "",
				})
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataList = data.body.records;
					this.totalCount = data.body.totalCount;
					this.pageIndex2 = this.page
				} else {
					this.dataList = []
					this.totalCount = 0
					this.pageIndex2 = 1
				}
			})
		},
		refirmHandle(id) {
			this.refirmVisible = true
			this.$nextTick(() => {
				this.$refs.workRefirm.init(id)
			})
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 190;
			return { height: height + 'px' }
		},
		handleSelectionChange(val) {
			this.tableSelVal = val;
			if (val.length > 0) {
				this.disabledBatchDelete = false;
			} else {
				this.disabledBatchDelete = true;
			}
		},
		tableRowClassName({ row, rowIndex }) {
			let color = ''
			for (let item of this.tableSelVal) {
				if (item.id === row.id) color = 'table-SelectedRow-bgcolor'
			}
			return color
		},
		// 每页数
		sizeChangeHandle(val) {
			this.limit = val
			this.page = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.page = val
			this.getDataList()
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVal.map((item) => item.recNo);
			if (checkIdList.includes(row.recNo)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.my-pagination {
	margin-right: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}
</style>
